import React, { useState, useEffect } from "react";
import Sidebar from "../components/Sidebar";

export default function DistrictDashboard() {
  const [userName, setUserName] = useState("");

  useEffect(() => {
    const name = localStorage.getItem("userName");
    if (name) {
      setUserName(name);
    }
  }, []);

  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return "Good Morning";
    if (hour < 17) return "Good Afternoon";
    return "Good Evening";
  };

  return (
    <div className="dashboard-container">
      <Sidebar />
      <div className="dashboard-content">
        {/* Decorative Welcome Section */}
        <div className="welcome-card">
          {/* Animated Background Decorations */}
          <div className="decorative-bg">
            <div className="floating-dots"></div>
            <div className="floating-shape shape-1">✨</div>
            <div className="floating-shape shape-2">🎯</div>
            <div className="floating-shape shape-3">🏆</div>
            <div className="floating-shape shape-4">⭐</div>
            <div className="gradient-orb orb-1"></div>
            <div className="gradient-orb orb-2"></div>
          </div>

          {/* Main Content */}
          <div className="welcome-content-wrapper">
            <div className="logo-section">
              <div className="logo-frame">
                <img 
                  src="/district-logo.png" 
                  alt="District Logo" 
                  className="district-logo"
                />
                <div className="logo-glow"></div>
              </div>
            </div>

            <div className="welcome-section">
              <div className="greeting-chip">
                <span className="greeting-emoji">
                  {getGreeting() === "Good Morning" ? "🌅" : getGreeting() === "Good Afternoon" ? "☀️" : "🌙"}
                </span>
                <span>{getGreeting()}</span>
              </div>
              
              <h1 className="dashboard-title">
                District Coordinator Dashboard
              </h1>
              
              <div className="user-welcome-card">
                <div className="name-highlight">
                  <span className="waving-hand">👋</span>
                  <span className="welcome-text">Welcome,</span>
                  <span className="user-name">{userName || "District Coordinator"}</span>
                  <span className="celebration">!</span>
                </div>
                <div className="role-badge">
                  <span className="badge-icon">📍</span>
                  <span>District Level Access</span>
                </div>
              </div>

              <div className="motivation-message">
                <div className="message-line">
                  <span className="quote-mark">"</span>
                  Empowering districts through efficient healthcare management
                  <span className="quote-mark">"</span>
                </div>
              </div>

              <div className="action-hints">
                <div className="hint-item">
                  <span className="hint-icon">📋</span>
                  <span>Manage Beneficiaries</span>
                </div>
                <div className="hint-item">
                  <span className="hint-icon">💳</span>
                  <span>Issue Health Cards</span>
                </div>
                <div className="hint-item">
                  <span className="hint-icon">📊</span>
                  <span>Track Performance</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Dashboard Body - Your existing content goes here */}
        <div className="dashboard-body">
          {/* Your dashboard content */}
        </div>
      </div>

      <style jsx>{`
        .welcome-card {
          background: linear-gradient(135deg, #1e3c72 0%, #2a5298 50%, #1e3c72 100%);
          border-radius: 24px;
          margin-bottom: 30px;
          position: relative;
          overflow: hidden;
          box-shadow: 0 15px 35px rgba(0,0,0,0.2);
          transition: all 0.3s ease;
        }

        /* Decorative Background */
        .decorative-bg {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          overflow: hidden;
          pointer-events: none;
        }

        .floating-dots {
          position: absolute;
          width: 100%;
          height: 100%;
          background-image: radial-gradient(circle at 30% 40%, rgba(255,255,255,0.1) 2px, transparent 2px);
          background-size: 30px 30px;
          animation: floatDots 20s linear infinite;
        }

        @keyframes floatDots {
          0% { transform: translateY(0); }
          100% { transform: translateY(-30px); }
        }

        .floating-shape {
          position: absolute;
 font-size: 24px;
          opacity: 0.15;
          animation: floatShape 8s ease-in-out infinite;
        }

        .shape-1 {
          top: 20%;
          left: 10%;
          animation-delay: 0s;
        }

        .shape-2 {
          top: 60%;
          right: 15%;
          animation-delay: 2s;
          font-size: 32px;
        }

        .shape-3 {
          bottom: 15%;
          left: 20%;
          animation-delay: 4s;
          font-size: 28px;
        }

        .shape-4 {
          top: 40%;
          right: 25%;
          animation-delay: 6s;
          font-size: 20px;
        }

        @keyframes floatShape {
          0%, 100% { transform: translateY(0) rotate(0deg); }
          50% { transform: translateY(-20px) rotate(10deg); }
        }

        .gradient-orb {
          position: absolute;
          border-radius: 50%;
          filter: blur(60px);
          opacity: 0.3;
          animation: pulseOrb 8s ease-in-out infinite;
        }

        .orb-1 {
          width: 300px;
          height: 300px;
          background: radial-gradient(circle, rgba(255,255,255,0.8), rgba(102,126,234,0.8));
          top: -150px;
          right: -100px;
        }

        .orb-2 {
          width: 250px;
          height: 250px;
          background: radial-gradient(circle, rgba(118,75,162,0.8), rgba(102,126,234,0.8));
          bottom: -120px;
          left: -80px;
          animation-delay: 4s;
        }

        @keyframes pulseOrb {
          0%, 100% { transform: scale(1); opacity: 0.3; }
          50% { transform: scale(1.2); opacity: 0.5; }
        }

        /* Content Wrapper */
        .welcome-content-wrapper {
          position: relative;
          padding: 40px;
          display: flex;
          gap: 40px;
          align-items: center;
          z-index: 1;
        }

        /* Logo Section */
        .logo-section {
          flex-shrink: 0;
        }

        .logo-frame {
          position: relative;
          width: 120px;
          height: 120px;
          background: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 10px 30px rgba(0,0,0,0.2);
          animation: borderGlow 3s ease-in-out infinite;
        }

        @keyframes borderGlow {
          0%, 100% { box-shadow: 0 0 0 0 rgba(255,255,255,0.4); }
          50% { box-shadow: 0 0 0 10px rgba(255,255,255,0.1); }
        }

        .district-logo {
          width: 100px;
          height: 100px;
          object-fit: contain;
          border-radius: 50%;
        }

        .logo-glow {
          position: absolute;
          width: 100%;
          height: 100%;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(255,255,255,0.3), transparent);
          animation: glow 2s ease-in-out infinite;
        }

        @keyframes glow {
          0%, 100% { opacity: 0.5; }
          50% { opacity: 1; }
        }

        /* Welcome Section */
        .welcome-section {
          flex: 1;
          color: white;
        }

        .greeting-chip {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: rgba(255,255,255,0.2);
          backdrop-filter: blur(10px);
          padding: 6px 16px;
          border-radius: 50px;
          font-size: 14px;
          font-weight: 500;
          margin-bottom: 20px;
          border: 1px solid rgba(255,255,255,0.3);
        }

        .greeting-emoji {
          font-size: 16px;
        }

        .dashboard-title {
          font-size: 32px;
          font-weight: 700;
          margin: 0 0 15px 0;
          letter-spacing: -0.5px;
          background: linear-gradient(135deg, #fff, #e0e7ff);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .user-welcome-card {
          background: rgba(255,255,255,0.15);
          backdrop-filter: blur(10px);
          border-radius: 16px;
          padding: 15px 20px;
          margin-bottom: 20px;
          border: 1px solid rgba(255,255,255,0.2);
        }

        .name-highlight {
          display: flex;
          align-items: center;
          gap: 10px;
          flex-wrap: wrap;
          font-size: 22px;
          font-weight: 600;
          margin-bottom: 10px;
        }

        .waving-hand {
          animation: wave 1.5s ease-in-out infinite;
          display: inline-block;
        }

        @keyframes wave {
          0%, 100% { transform: rotate(0deg); }
          25% { transform: rotate(20deg); }
          75% { transform: rotate(-10deg); }
        }

        .welcome-text {
          font-weight: 400;
        }

        .user-name {
          background: linear-gradient(135deg, #FFD700, #FFA500);
          padding: 4px 12px;
          border-radius: 8px;
          color: #1e3c72;
        }

        .celebration {
          font-size: 28px;
          animation: bounce 1s ease-in-out infinite;
        }

        @keyframes bounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-5px); }
        }

        .role-badge {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          background: rgba(0,0,0,0.2);
          padding: 4px 12px;
          border-radius: 8px;
          font-size: 12px;
          font-weight: 500;
        }

        .badge-icon {
          font-size: 14px;
        }

        .motivation-message {
          margin-bottom: 20px;
          padding: 10px;
          text-align: center;
        }

        .message-line {
          font-size: 14px;
          font-style: italic;
          opacity: 0.9;
        }

        .quote-mark {
          font-size: 20px;
          font-weight: 700;
          margin: 0 5px;
          opacity: 0.7;
        }

        .action-hints {
          display: flex;
          gap: 20px;
          flex-wrap: wrap;
        }

        .hint-item {
          display: flex;
          align-items: center;
          gap: 8px;
          background: rgba(255,255,255,0.1);
          padding: 6px 12px;
          border-radius: 8px;
          font-size: 12px;
          backdrop-filter: blur(5px);
          transition: all 0.3s ease;
        }

        .hint-item:hover {
          background: rgba(255,255,255,0.2);
          transform: translateY(-2px);
        }

        .hint-icon {
          font-size: 14px;
        }

        .dashboard-body {
          background: white;
          border-radius: 20px;
          padding: 20px;
          box-shadow: 0 2px 10px rgba(0,0,0,0.05);
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .welcome-content-wrapper {
            flex-direction: column;
            text-align: center;
            padding: 30px;
          }

          .dashboard-title {
            font-size: 24px;
          }

          .name-highlight {
            justify-content: center;
            font-size: 18px;
          }

          .action-hints {
            justify-content: center;
          }
        }
      `}</style>
    </div>
  );
}